<main class="main">
  <!-- Div con titolo e sottotitolo -->
  <div class="main-content">
    <!--<h1 class="main-title">{{ 'PROFILE.TITLE' | translate }}</h1>
    <p class="main-subtitle">{{ 'PROFILE.SUBTITLE' | translate }}</p>-->

    <!-- Sezione dati utente -->
    <div class="profile-section" *ngIf="userProfile">
      <div class="profile-header">
        <div class="profile-avatar">          <!-- Avatar o iniziali utente -->
          <div class="initials">{{ currentProfile?.userName?.charAt(0) || 'U' }}</div>
        </div>
        <div class="profile-info">
          <h2 class="profile-name">{{ currentProfile?.userName }}</h2>
          <div class="profile-status" [ngClass]="{'status-active': currentProfile?.userStatus === 'ACTIVE'}">
            {{ currentProfile?.userStatus }}
          </div>
          <p class="profile-role">{{ currentProfile?.userType }}</p>
        </div>
        <div class="profile-actions">
          <button class="btn btn-primary" (click)="toggleEditMode()" [disabled]="isSaving">
            {{ isEditing ? ('COMMON.CANCEL' | translate) : ('COMMON.EDIT' | translate) }}
          </button>
          <button *ngIf="isEditing" class="btn btn-success" (click)="saveChanges()" [disabled]="isSaving">
            {{ isSaving ? ('COMMON.SAVING' | translate) : ('COMMON.SAVE' | translate) }}
          </button>
        </div>
      </div>

      <!-- Messaggi di feedback -->
      <div *ngIf="saveSuccess" class="alert alert-success">
        {{ 'COMMON.SUCCESS' | translate }}
      </div>
      <div *ngIf="saveError" class="alert alert-danger">
        {{ 'COMMON.ERROR' | translate }}
      </div>

      <div class="profile-content">
        <div class="profile-card">
          <h3 class="card-title"><span class="card-title-icon"><i class="fas fa-user"></i></span>{{ 'PROFILE.PERSONAL_INFO' | translate }}</h3>
          <div class="profile-fields">
            <div class="field-group">
              <label>{{ 'PROFILE.ID' | translate }}</label>
              <!-- Campo ID non modificabile -->
              <p>{{ currentProfile?.userCode }}</p>
            </div>
            <div class="field-group">
              <label>{{ 'PROFILE.EMAIL' | translate }}</label>
              <ng-container *ngIf="!isEditing; else emailEdit">
                <p>{{ currentProfile?.userEmail }}</p>
              </ng-container>
              <ng-template #emailEdit>
                <input type="email" class="form-control" [(ngModel)]="editableProfile!.userEmail">
              </ng-template>
            </div>
            <div class="field-group">
              <label>{{ 'PROFILE.PHONE' | translate }}</label>
              <ng-container *ngIf="!isEditing; else phoneEdit">
                <p>{{ currentProfile?.phoneNumber }}</p>
              </ng-container>
              <ng-template #phoneEdit>
                <input type="tel" class="form-control" [(ngModel)]="editableProfile!.phoneNumber">
              </ng-template>
            </div>
            <div class="field-group">
              <label>{{ 'PROFILE.LANGUAGE' | translate }}</label>
              <ng-container *ngIf="!isEditing; else languageEdit">
                <p>{{ currentProfile?.userLanguage }}</p>
              </ng-container>
              <ng-template #languageEdit>
                <select class="form-control" [(ngModel)]="editableProfile!.userLanguage">
                  <option *ngFor="let lang of availableLanguages" [value]="lang">{{ lang | uppercase }}</option>
                </select>
              </ng-template>
            </div>
            <div class="field-group">
              <label>{{ 'PROFILE.REGISTRATION_DATE' | translate }}</label>
              <p>{{ getFormattedDate(currentProfile?.userRegistrationDate || '') }}</p>
            </div>
            <div class="field-group">
              <label>{{ 'PROFILE.LAST_LOGIN' | translate }}</label>
              <p>{{ getFormattedDate(currentProfile?.userLastLoginDate || '') }}</p>
            </div>
          </div>
        </div>

        <div class="profile-card">
          <h3 class="card-title"><span class="card-title-icon"><i class="fas fa-map-marker-alt"></i></span>{{ 'PROFILE.ADDRESS' | translate }}</h3>
          <div class="profile-fields">
            <div class="field-group">
              <label>{{ 'PROFILE.STREET' | translate }}</label>
              <ng-container *ngIf="!isEditing; else streetEdit">
                <p>{{ currentProfile?.userAddressStreet }}, {{ currentProfile?.userAddressNumber }}</p>
              </ng-container>
              <ng-template #streetEdit>
                <div class="address-inputs">
                  <input type="text" class="form-control street" [(ngModel)]="editableProfile!.userAddressStreet" placeholder="Via">
                  <input type="text" class="form-control number" [(ngModel)]="editableProfile!.userAddressNumber" placeholder="N°">
                </div>
              </ng-template>
            </div>
            <div class="field-group">
              <label>{{ 'PROFILE.CITY' | translate }}</label>
              <ng-container *ngIf="!isEditing; else cityEdit">
                <p>{{ currentProfile?.userAddressCity }} ({{ currentProfile?.userAddressProvince }})</p>
              </ng-container>
              <ng-template #cityEdit>
                <div class="address-inputs">
                  <input type="text" class="form-control city" [(ngModel)]="editableProfile!.userAddressCity" placeholder="Città">
                  <input type="text" class="form-control province" [(ngModel)]="editableProfile!.userAddressProvince" placeholder="Provincia">
                </div>
              </ng-template>
            </div>
            <div class="field-group">
              <label>{{ 'PROFILE.ZIP' | translate }}</label>
              <ng-container *ngIf="!isEditing; else zipEdit">
                <p>{{ currentProfile?.userAddressZip }}</p>
              </ng-container>
              <ng-template #zipEdit>
                <input type="text" class="form-control" [(ngModel)]="editableProfile!.userAddressZip">
              </ng-template>
            </div>
            <div class="field-group">
              <label>{{ 'PROFILE.COUNTRY' | translate }}</label>
              <ng-container *ngIf="!isEditing; else countryEdit">
                <p>{{ currentProfile?.userAddressCountry }}</p>
              </ng-container>
              <ng-template #countryEdit>
                <input type="text" class="form-control" [(ngModel)]="editableProfile!.userAddressCountry">
              </ng-template>
            </div>
          </div>
        </div>

        <div class="profile-card">
          <h3 class="card-title"><span class="card-title-icon"><i class="fas fa-id-badge"></i></span>{{ 'PROFILE.AFFILIATION' | translate }}</h3>
          <div class="profile-fields">
            <div class="field-group">
              <label>{{ 'PROFILE.AFFILIATION_TYPE' | translate }}</label>
              <ng-container *ngIf="!isEditing; else affiliationTypeEdit">
                <p>{{ currentProfile?.userAffiliationType }}</p>
              </ng-container>
              <ng-template #affiliationTypeEdit>
                <select class="form-control" [(ngModel)]="editableProfile!.userAffiliationType">
                  <option *ngFor="let type of availableAffiliationTypes" [value]="type">{{ type }}</option>
                </select>
              </ng-template>
            </div>
            <div class="field-group">
              <label>{{ 'PROFILE.AFFILIATION_CODE' | translate }}</label>
              <ng-container *ngIf="!isEditing; else affiliationCodeEdit">
                <p>{{ currentProfile?.userAffiliationCode }}</p>
              </ng-container>
              <ng-template #affiliationCodeEdit>
                <input type="text" class="form-control" [(ngModel)]="editableProfile!.userAffiliationCode">
              </ng-template>
            </div>
            <div class="field-group">
              <label>{{ 'PROFILE.NOTES' | translate }}</label>
              <ng-container *ngIf="!isEditing; else notesEdit">
                <p>{{ currentProfile?.userNotes || ('PROFILE.NO_NOTES' | translate) }}</p>
              </ng-container>
              <ng-template #notesEdit>
                <textarea class="form-control" [(ngModel)]="editableProfile!.userNotes" rows="3"></textarea>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Messaggio di caricamento quando i dati non sono ancora pronti -->
    <div class="loading-message" *ngIf="!userProfile">
      <p>{{ 'COMMON.LOADING' | translate }}</p>
    </div>

    <!-- Sezione con card informative/azioni
    <div class="card-container">
      <a class="card-dashed" href="/login">
        <div class="card-arrow">→</div>
        <h3>{{ 'PROFILE.MESSAGES.REQUEST_PERMISSION.TITLE' | translate }}</h3>
        <p>{{ 'PROFILE.MESSAGES.REQUEST_PERMISSION.DESCRIPTION' | translate }}</p>
      </a>
    </div> -->
  </div>
</main>